import { getSso } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'sso/FETCH_START',
  FETCH_SUCCESS: 'sso/FETCH_SUCCESS',
  FETCH_ERROR: 'sso/FETCH_ERROR',
}

export const fetchSso = queryParams => async dispatch => {
  const agentId =
    queryParams.get('sso') || queryParams.get('z') || queryParams.get('cptok')
  const sessionId = queryParams.get('sessionId')

  if (agentId) {
    dispatch({ type: actionTypes.FETCH_START })
    try {
      const { data } = await getSso(agentId, sessionId)
      return dispatch({ type: actionTypes.FETCH_SUCCESS, payload: data })
    } catch (error) {
      return dispatch({
        type: actionTypes.FETCH_ERROR,
        payload: error?.message,
      })
    }
  } else {
    return dispatch({
      type: actionTypes.FETCH_ERROR,
      payload: 'Authentication token is required',
    })
  }
}
